import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettingsComponent } from "../ProtocolSettingsComponent";
import { SshSettings } from 'DiscoveryEngine.TS/Protocols';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';

@Component({
	selector: 'ssh-settings',
	templateUrl: './ssh-settings.component.html',
	styleUrls: ['./ssh-settings.component.scss']
})
export class SshSettingsComponent extends ProtocolSettingsComponent<SshSettings> implements OnChanges {

	public Name: UntypedFormControl;
	public Username: UntypedFormControl;
	public Password: UntypedFormControl;
	public PasswordConfirm: UntypedFormControl;
	public EnablePassword: UntypedFormControl;
	public EnablePasswordConfirm: UntypedFormControl;
	public ShowChars: UntypedFormControl;
	public IpScope: UntypedFormControl;
	public Port: UntypedFormControl;
	public LoginTimeout: UntypedFormControl;
	public ReadTimeout: UntypedFormControl;
	public ReadPause: UntypedFormControl;
	public IsDefault: UntypedFormControl;

	private PasswordChanged: boolean;
	private EnablePasswordChanged: boolean;

	constructor(private fb: UntypedFormBuilder) {
		super();
		this.BuildForm();
	}

	protected BuildForm(): void {
		this.PasswordInputType = "password";

		if (this.Settings) {
			this.Name = new UntypedFormControl(this.Settings.Name, Validators.required);
			this.Username = new UntypedFormControl(this.Settings.UserName, Validators.required);
			this.Password = new UntypedFormControl(this.hidePassword(this.Settings.Password));
			this.PasswordConfirm = new UntypedFormControl(this.hidePassword(this.Settings.Password));
			this.EnablePassword = new UntypedFormControl(this.hidePassword(this.Settings.EnablePassword));
			this.EnablePasswordConfirm = new UntypedFormControl(this.hidePassword(this.Settings.EnablePassword));
			this.ShowChars = new UntypedFormControl(false);
			this.IpScope = new UntypedFormControl(this.Settings.IpScope.ToString());
			this.Port = new UntypedFormControl(this.Settings.Port, Validators.compose([Validators.required, this.minValue(1), this.maxValue(65535)]));
			this.LoginTimeout = new UntypedFormControl(this.Settings.LoginTimeout, Validators.compose([Validators.required, this.minValue(0), this.maxValue(120000)]));
			this.ReadTimeout = new UntypedFormControl(this.Settings.ReadTimeout, Validators.compose([Validators.required, this.minValue(0), this.maxValue(120000)]));
			this.ReadPause = new UntypedFormControl(this.Settings.ReadPause, Validators.compose([Validators.required, this.minValue(0), this.maxValue(120000)]));
			this.IsDefault = new UntypedFormControl(this.Settings.IsDefault);

			this.enableDisableControls();

			this.PasswordChanged = false;
			this.EnablePasswordChanged = false;

			this.SettingsForm = this.fb.group({
				Name: this.Name,
				Username: this.Username,
				Password: this.Password,
				PasswordConfirm: this.PasswordConfirm,
				EnablePassword: this.EnablePassword,
				EnablePasswordConfirm: this.EnablePasswordConfirm,
				ShowChars: this.ShowChars,
				IpScope: this.IpScope,
				Port: this.Port,
				LoginTimeout: this.LoginTimeout,
				ReadTimeout: this.ReadTimeout,
				ReadPause: this.ReadPause,
				IsDefault: this.IsDefault,
			},
				{
					validator: Validators.compose([
						this.equalTo(this.Password, this.PasswordConfirm, "passwordsEqual"),
						this.equalTo(this.EnablePassword, this.EnablePasswordConfirm, "enablePasswordsEqual")])
				});
		}
		else {
			this.SettingsForm = null;
			this.Name = null;
			this.Username = null;
			this.Password = null;
			this.PasswordConfirm = null;
			this.EnablePassword = null;
			this.EnablePasswordConfirm = null;
			this.ShowChars = null;
			this.IpScope = null;
			this.Port = null;
			this.LoginTimeout = null;
			this.ReadTimeout = null;
			this.ReadPause = null;
			this.IsDefault = null;
		}
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.ShowChars, this.AllowShowChars);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public get invalidTempChanges(): string[] {
		return ["SSH"];
	}

	public applyTempChanges(): void {
		this.Settings.Name = this.Name.value;
		this.Settings.UserName = this.Username.value;
		if (this.PasswordChanged) {
			this.Settings.Password = StringUtils.ObfuscateString2(this.Password.value);
		}
		if (this.EnablePasswordChanged) {
			this.Settings.EnablePassword = StringUtils.ObfuscateString2(this.EnablePassword.value);
		}
		this.Settings.IpScope.FromString(this.IpScope.value);
		this.Settings.Port = parseInt(this.Port.value);
		this.Settings.LoginTimeout = parseInt(this.LoginTimeout.value);
		this.Settings.ReadTimeout = parseInt(this.ReadTimeout.value);
		this.Settings.ReadPause = parseInt(this.ReadPause.value);
		this.Settings.IsDefault = this.IsDefault.value;

		this.BuildForm();
		this.OnApplyTempChanges();
	}

}
